import React, { useState, useEffect } from "react";
import { getAllImages, getAppParams } from "../../api/api";
import "toastr/build/toastr.min.css";
import "../colors/colors.css";
import Select from "react-select";
import { UserLang } from "../../store/userStore";
import ToolTip from "../tooltip/tooltip";
import Button from "react-bootstrap/Button";
import LabelImage from "../cards/image";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MyVerticallyCenteredModal from "../imgUpload/modal";

const EPGDetails = (props) => {
  const lan = UserLang.useState((s) => s.lan);
  const [characters, updateCharacters] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [allImage, setallImage] = useState([]);
  const [hold, setHold] = useState([]);

  const handleSave = (evt) => {
    evt.preventDefault();
    const opt = {
      description: hold.description,
      title: hold.title,
      image: hold.image,
      Year: hold.Year,
      Director: hold.Director,
      Actors: hold.Actors,
      Genre: hold.Genre,
      Rated: hold.Rated,
      Released: hold.Released,
      Language: hold.Language,
      since: hold.since,
      till: hold.till,
      order: characters.length + 1,
    };

    updateCharacters([...characters, opt]);
    const newArr = [...characters, opt];
    props.onChange(newArr);
  };

  useEffect(() => {
    /* eslint-disable no-unused-vars */
    const getImage = async () => {
      try {
        const appl = await getAllImages(100, 0);

        const images = appl.data.images;
        const opt = images.map((item) => ({
          value: item.imagekey,
          label: (
            <LabelImage
              url={getAppParams() + item.imagekey}
              name={item.imageName}
            ></LabelImage>
          ),
          key: item.imagekey,
          name: item.imageName,
          id: item._id,
        }));

        setallImage(opt);
      } catch (error) {}
    };

    const getDetails = () => {
      if (props.listData[0]) {
        const items = Array.from(props.listData);
        if (props.array) {
          items.splice(props.array.order - 1, 1);

          items.splice(props.array.order - 1, 0, props.array);

          const opt = items.map((item, index) => ({
            description: item.description,
            title: item.title,
            image: item.image,
            Year: item.Year,
            Director: item.Director,
            Actors: item.Actors,
            Genre: item.Genre,
            Rated: item.Rated,
            Released: item.Released,
            Language: item.Language,
            since: item.since,
            till: item.till,
            order: index + 1,
          }));

          updateCharacters(opt);

          const newArr = opt;
          props.onChange(newArr);
        } else {
          const opt = items.map((item, index) => ({
            description: item.description,
            title: item.title,
            image: item.image,
            Year: item.Year,
            Director: item.Director,
            Actors: item.Actors,
            Genre: item.Genre,
            Rated: item.Rated,
            Released: item.Released,
            Language: item.Language,
            since: item.since,
            till: item.till,
            order: index + 1,
          }));

          updateCharacters(opt);
        }
      }
    };
    if (props.listData) getDetails();
    getImage();
    /* eslint-disable no-unused-vars */
    // eslint-disable-next-line
  }, [props.data, props.listData, props.list]);
  const handleDetails = (evt) => {
    const value = evt.target.value;
    setHold({
      ...hold,
      [evt.target.name]: value,
    });
  };

  const filterOption = (option, searchText) => {
    if (option.data.name.toLowerCase().includes(searchText.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  };

  const handleDetail = (value, evt) => {
    setHold({
      ...hold,
      [value.name]: value.key,
    });
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(characters);
    const [reorderedItem] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, reorderedItem);

    reorderArray(items);
  };

  const reorderArray = (items) => {
    const newItems = items.map((item, index) => {
      item.order = index + 1;
      return item;
    });
    updateCharacters(newItems);
    const newArr = newItems;

    props.onChange(newArr);
  };

  const handleRemove = (event, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(characters);
    items.splice(index, 1);

    reorderArray(items);
  };

  const handleSubmit = (employee) => {
    props.history.push("/epgdetail", {
      id: employee,
      array: characters,
      url: props.url,
    });
  };

  return (
    <div className="row mb-2 mt-2">
      <div className="col-sm-12">
        <div className="row mb-2 mt-2"></div>
        <div className="row mb-2 mt-2"></div>
        <div className="row">
          <div className="col-sm-6">
            {/* text input */}
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>}&nbsp; */}
                Description &nbsp;
                {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>} */}
              </label>
              <textarea
                name="description"
                dir={lan === "rtl" ? "rtl" : "ltr"}
                className="form-control inside-form"
                placeholder="Description ..."
                defaultValue={characters.description}
                onChange={handleDetails}
                autoComplete="off"
              ></textarea>{" "}
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}/>}&nbsp; */}
                Title &nbsp;
                {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}
            place={"right"} />} */}
              </label>
              <input
                dir={lan === "rtl" ? "rtl" : "ltr"}
                type="text"
                name="title"
                className="form-control inside-form"
                placeholder="Title ..."
                defaultValue={characters.title}
                onChange={handleDetails}
                autoComplete="off"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            {/* text input */}
            <div className="form-group">
              <div className="row">
                {lan === "rtl" && (
                  <div className="col-md-4">
                    <Button
                      variant="light"
                      onClick={() => setModalShow(true)}
                      style={{
                        width: "100px",
                        marginTop: "8px",
                        height: "40px",
                      }}
                    >
                      Upload
                    </Button>
                  </div>
                )}
                <div className="col-md-8" dir={lan === "rtl" ? "rtl" : "ltr"}>
                  <label
                    className={lan === "rtl" ? "float-right" : "float-left"}
                  >
                    {/* {!(lan==="rtl")&&<ToolTip 
            info={"Banner image used in Banner field"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp; */}
                    Image
                    {/* &nbsp;{(     lan==="rtl")&&<ToolTip 
            info={"Banner image used in Banner field"}
            place={lan==="rtl"?"left":"right"}/>} */}
                  </label>
                  <Select
                    name="image"
                    className={
                      lan === "rtl"
                        ? "form-control inside-select float-right"
                        : "form-control inside-select float-left"
                    }
                    filterOption={filterOption}
                    options={allImage}
                    onChange={(value, event) => handleDetail(value, event)}
                  ></Select>
                </div>
                {!(lan === "rtl") && (
                  <div className="col-md-4">
                    <Button
                      variant="light"
                      onClick={() => setModalShow(true)}
                      style={{
                        width: "100px",
                        marginTop: "8px",
                        height: "40px",
                      }}
                    >
                      Upload
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}/>}&nbsp; */}
                Year &nbsp;
                {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}
            place={"right"} />} */}
              </label>
              <input
                dir={lan === "rtl" ? "rtl" : "ltr"}
                type="number"
                name="Year"
                className="form-control inside-form"
                placeholder="Year ..."
                defaultValue={characters.Year}
                onChange={handleDetails}
                autoComplete="off"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            {/* text input */}
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>}&nbsp; */}
                Director
                {/* &nbsp;
            {!(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>} */}
              </label>
              <input
                dir={lan === "rtl" ? "rtl" : "ltr"}
                type="text"
                name="Director"
                className="form-control inside-form"
                placeholder="Director ..."
                defaultValue={characters.Director}
                onChange={handleDetails}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}/>}&nbsp; */}
                Actors &nbsp;
                {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}
            place={"right"} />} */}
              </label>
              <input
                dir={lan === "rtl" ? "rtl" : "ltr"}
                type="text"
                name="Actors"
                className="form-control inside-form"
                placeholder="Actors ..."
                defaultValue={characters.Actors}
                onChange={handleDetails}
                autoComplete="off"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            {/* text input */}
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>}&nbsp; */}
                Genre &nbsp;
                {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>} */}
              </label>
              <input
                dir={lan === "rtl" ? "rtl" : "ltr"}
                type="text"
                name="Genre"
                className="form-control inside-form"
                placeholder="Genre ..."
                defaultValue={characters.Genre}
                onChange={handleDetails}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}/>}&nbsp; */}
                Rated &nbsp;
                {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}
            place={"right"} />} */}
              </label>
              <input
                dir={lan === "rtl" ? "rtl" : "ltr"}
                type="text"
                name="Rated"
                className="form-control inside-form"
                placeholder="Rated ..."
                defaultValue={characters.Rated}
                onChange={handleDetails}
                autoComplete="off"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            {/* text input */}
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>}&nbsp; */}
                Released &nbsp;
                {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Name used to identify this element on CMS"}/>} */}
              </label>
              <input
                dir={lan === "rtl" ? "rtl" : "ltr"}
                type="text"
                name="Released"
                className="form-control inside-form"
                placeholder="Released ..."
                defaultValue={characters.Released}
                onChange={handleDetails}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {/* {(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}/>}&nbsp; */}
                Language &nbsp;
                {/* {!(lan==="rtl")&&
              <ToolTip 
            info={"Title name for the element"}
            place={"right"} />} */}
              </label>
              <input
                dir={lan === "rtl" ? "rtl" : "ltr"}
                type="text"
                name="Language"
                className="form-control inside-form"
                placeholder="Language ..."
                defaultValue={characters.Language}
                onChange={handleDetails}
                autoComplete="off"
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-6">
            {/* text input */}
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {lan === "rtl" && (
                  <ToolTip info={"Name used to identify this element on CMS"} />
                )}
                &nbsp; Since &nbsp;
                {!(lan === "rtl") && (
                  <ToolTip info={"Name used to identify this element on CMS"} />
                )}
              </label>
              <input
                dir={lan === "rtl" ? "rtl" : "ltr"}
                type="text"
                name="since"
                className="form-control inside-form"
                placeholder="2022-01-01"
                defaultValue={characters.since}
                onChange={handleDetails}
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {lan === "rtl" && (
                  <ToolTip info={"Title name for the element"} />
                )}
                &nbsp; Till &nbsp;
                {!(lan === "rtl") && (
                  <ToolTip
                    info={"Title name for the element"}
                    place={"right"}
                  />
                )}
              </label>
              <input
                dir={lan === "rtl" ? "rtl" : "ltr"}
                type="text"
                name="till"
                className="form-control inside-form"
                placeholder="2022-01-01"
                defaultValue={characters.till}
                onChange={handleDetails}
                autoComplete="off"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div
            className={
              lan === "rtl"
                ? "float-left btn-group btn-group-md"
                : "float-right btn-group btn-group-md"
            }
            role="group"
          >
            <button
              onClick={handleSave}
              className="btn btn-light btn-block"
              style={{ width: "100px", marginRight: "6px" }}
            >
              Draft
            </button>
          </div>
        </div>
      </div>

      {
        <div className="col-sm-12">
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId={"characters"}>
              {(provided) => (
                <table
                  dir={props.dir === "rtl" ? "rtl" : "ltr"}
                  id="appadmin"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  className="table table-bordered table-hover dataTable dtr-inline"
                  role="grid"
                  aria-describedby="example2_info"
                >
                  <thead>
                    <tr role="row">
                      <th
                        className="sorting_asc"
                        tabIndex={0}
                        aria-controls="example2"
                        rowSpan={1}
                        colSpan={1}
                      >
                        {" "}
                        <label
                          className={
                            props.dir === "rtl" ? "float-right" : "float-left"
                          }
                        >
                          Order
                        </label>
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example2"
                        rowSpan={1}
                        colSpan={1}
                      >
                        <label
                          className={
                            props.dir === "rtl" ? "float-right" : "float-left"
                          }
                        >
                          Title
                        </label>
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example2"
                        rowSpan={1}
                        colSpan={1}
                      >
                        <label
                          className={
                            props.dir === "rtl" ? "float-right" : "float-left"
                          }
                        >
                          Since
                        </label>
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example2"
                        rowSpan={1}
                        colSpan={1}
                      >
                        <label
                          className={
                            props.dir === "rtl" ? "float-right" : "float-left"
                          }
                        >
                          Till
                        </label>
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example2"
                        rowSpan={1}
                        colSpan={1}
                      >
                        <label
                          className={
                            props.dir === "rtl" ? "float-right" : "float-left"
                          }
                        >
                          Edit
                        </label>
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example2"
                        rowSpan={1}
                        colSpan={1}
                      >
                        <label
                          className={
                            props.dir === "rtl" ? "float-right" : "float-left"
                          }
                        >
                          Delete
                        </label>
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {characters[0] &&
                      characters.map((person, index) => (
                        <Draggable
                          key={person.title + person.order}
                          draggableId={"item" + person.order}
                          index={index}
                        >
                          {(provided) => (
                            <tr
                              role="row"
                              className="even"
                              key={person.order}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <td
                                className="dtr-control sorting_1"
                                tabIndex={0}
                              >
                                <label
                                  className={
                                    props.dir === "rtl"
                                      ? "float-right"
                                      : "float-left"
                                  }
                                >
                                  {person.order}
                                </label>
                              </td>
                              <td>
                                <label
                                  className={
                                    props.dir === "rtl"
                                      ? "float-right"
                                      : "float-left"
                                  }
                                >
                                  {person.title}
                                </label>
                              </td>
                              <td>
                                <label
                                  className={
                                    props.dir === "rtl"
                                      ? "float-right"
                                      : "float-left"
                                  }
                                >
                                  {person.since}
                                </label>
                              </td>
                              <td>
                                <label
                                  className={
                                    props.dir === "rtl"
                                      ? "float-right"
                                      : "float-left"
                                  }
                                >
                                  {person.till}
                                </label>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  onClick={(event) => handleSubmit(person)}
                                  className={
                                    props.dir === "rtl"
                                      ? "float-right btn btn-light"
                                      : "float-left btn btn-light"
                                  }
                                >
                                  Details
                                </button>
                              </td>
                              <td>
                                <button
                                  type="button"
                                  className={
                                    props.dir === "rtl"
                                      ? "float-right btn btn-light"
                                      : "float-left btn btn-light"
                                  }
                                  onClick={(event) =>
                                    handleRemove(event, index)
                                  }
                                >
                                  <i className="fa fa-trash"></i> Delete
                                </button>
                              </td>
                            </tr>
                          )}
                        </Draggable>
                      ))}

                    {provided.placeholder}
                  </tbody>
                </table>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      }

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        allimage={allImage}
      />
    </div>
  );
};

export default EPGDetails;
